import $ from 'jquery';
import 'jquery-circle-progress';

$( '.c-progress__bar' ).circleProgress( {
	startAngle: -Math.PI / 4 * 2,
	value: 0.99,
	size: 125,
	thickness: 12,
	fill: '#e4aa00',
} ).on( 'circle-animation-progress', function( event, progress, stepValue ) {
	$( this ).find( '.c-progress__value' ).text( stepValue.toFixed( 2 ).substr( 2 ) );
} );
